module.exports = __webpack_public_path__ + "static/media/users-cog.a320cd1f.svg";